"use client";

import { useEffect, useRef, useState } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheMysticalAwakeningHero() {
  const {
    ref: contentRef,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const [scrollY, setScrollY] = useState(0);
  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section data-section-id="230776" id="elevated-wellness-hero" className="dark bg-background text-foreground relative min-h-screen flex flex-col items-center justify-center overflow-hidden">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1652321/img/dark_gray_marble_bg.png)]" style={{
      transform: `translateY(${scrollY * 0.25}px)`
    }} />

      {}
      <div className="absolute inset-0 pointer-events-none opacity-60" style={{
      backgroundImage: `radial-gradient(#A89080 1px, transparent 1px)`,
      backgroundSize: '30px 30px',
      transform: `translateY(${scrollY * 0.15}px)`
    }} />

      {}
      <div className="absolute inset-0 bg-background/40 backdrop-blur-[2px]" />

      {}
      <div className="absolute top-0 left-0 right-0 h-px opacity-20" style={{
      background: "var(--border)"
    }} />

      {}
      <div ref={contentRef} className="relative z-10 flex flex-col items-center justify-center text-center px-6 max-w-4xl mx-auto !text-[rgba(128,124,119,1)]" style={{
      opacity: isVisible ? 1 : 0,
      transform: isVisible ? "translateY(0)" : "translateY(40px)",
      transition: "opacity 1.2s ease, transform 1.2s ease"
    }}><div className="mb-8 flex flex-col items-center gap-1 !text-[rgba(175,179,182,1)]" data-ast-id="f:/src/pages/Home/sections/TheMysticalAwakeningHero.tsx|sig:hex3es" data-ast-start="1688" data-ast-end="2222" style={{
        opacity: '1',
        transition: 'opacity 1.4s 0.2s'
      }}><span className="font-default text-xs tracking-widest uppercase font-bold" data-ast-id="f:/src/pages/Home/sections/TheMysticalAwakeningHero.tsx|sig:f9e89o" data-ast-start="1956" data-ast-end="2102" style={{
          color: 'var(--primary)'
        }} contenteditable="false">The highest Standard</span>
        <span className="font-mono text-[10px] tracking-[0.2em] uppercase font-bold" style={{
          color: '#A89080',
          filter: 'drop-shadow(0 0 16px rgba(168, 144, 128, 0.5))'
        }}>IN WELLNESS</span>
        </div><h1 className="font-default text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-light leading-tight mb-8 text-foreground" data-ast-id="f:/src/pages/Home/sections/TheMysticalAwakeningHero.tsx|sig:kc9juf" data-ast-start="2243" data-ast-end="2932" style={{
        fontFamily: 'var(--font-serif)',
        letterSpacing: '-0.02em',
        opacity: '1',
        transform: 'translateY(0px)',
        transition: 'opacity 1.4s 0.4s, transform 1.4s 0.4s'
      }} contenteditable="false">The Protocol to <span className="italic" data-ast-id="f:/src/pages/Home/sections/TheMysticalAwakeningHero.tsx|sig:p8v9dp" data-ast-start="2873" data-ast-end="3157" contenteditable="false" style={{
          color: '#8FA88F'
        }}>Measure. Optimize. Perform. Maintain.</span></h1><p className="font-default text-sm max-w-xl mx-auto mb-10 leading-relaxed text-[#A89080] sm:text-base md:text-lg font-bold" data-ast-id="f:/src/pages/Home/sections/TheMysticalAwakeningHero.tsx|sig:bldypa" data-ast-start="2953" data-ast-end="3479" style={{
        opacity: '1',
        transform: 'translateY(0px)',
        transition: 'opacity 1.4s 0.6s, transform 1.4s 0.6s',
        filter: 'drop-shadow(0 0 20px rgba(168, 144, 128, 0.4))'
      }} contenteditable="false">Experience high-end medical wellness with clinical precision. From personalized wellness protocols to advanced lab testing, we help optimize your health, vitality, and overall well-being.</p><div className="flex flex-col sm:flex-row gap-4" data-ast-id="f:/src/pages/Home/sections/TheMysticalAwakeningHero.tsx|sig:z1n9ie" data-ast-start="3500" data-ast-end="4449" style={{
        opacity: '1',
        transform: 'translateY(0px)',
        transition: 'opacity 1.4s 0.8s, transform 1.4s 0.8s'
      }}><Link data-ast-id="f:/src/pages/Home/sections/TheMysticalAwakeningHero.tsx|sig:a1aqaq" data-ast-start="4019" data-ast-end="4055" data-slot="button" className="inline-flex items-center justify-center gap-2 whitespace-nowrap font-medium disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg:not([class*='size-'])]:size-4 shrink-0 [&amp;_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive shadow-xs h-9 has-[&gt;svg]:px-3 font-default text-xs tracking-[0.2em] uppercase px-4 py-2 rounded-md bg-[#8FA88F] text-white hover:bg-[#8FA88F]/90 transition-all duration-300" to="https://booking.mangomint.com/811506" target="_blank" rel="noopener noreferrer">Book Appointment</Link><Link data-ast-id="f:/src/pages/Home/sections/TheMysticalAwakeningHero.tsx|sig:9zkmmz" data-ast-start="4367" data-ast-end="4414" data-slot="button" className="inline-flex items-center justify-center gap-2 whitespace-nowrap font-medium disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg:not([class*='size-'])]:size-4 shrink-0 [&amp;_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive shadow-xs h-9 has-[&gt;svg]:px-3 font-default text-xs tracking-[0.2em] uppercase px-4 py-2 bg-[#8FA88F] text-white rounded-md hover:bg-[#8FA88F]/90 transition-all duration-300" to="/ShopPage">Shop the Collection</Link></div></div>

      <style>{`
        
      `}</style>
    </section>;
}